import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useClientes } from "../hooks/useClientes";
import { useUsuarios } from "../hooks/useRoles";
import { useActividadesCliente } from "../hooks/useActividadesCliente";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const ESTADOS   = ["Nuevo", "Contactado", "Propuesta", "Negociación", "Cerrado", "Perdido"];
const FUENTES   = ["Referido", "Web", "LinkedIn", "Instagram", "Google Ads", "WhatsApp", "Evento", "Otro"];
const PRIORIDAD = ["1 - Baja", "2", "3 - Media", "4", "5 - Alta"];

const DEPARTAMENTOS = [
  "Amazonas","Áncash","Apurímac","Arequipa","Ayacucho","Cajamarca","Callao",
  "Cusco","Huancavelica","Huánuco","Ica","Junín","La Libertad","Lambayeque",
  "Lima","Loreto","Madre de Dios","Moquegua","Pasco","Piura","Puno",
  "San Martín","Tacna","Tumbes","Ucayali",
];

const TIPOS_ACTIVIDAD = [
  { key: "Llamada",       icon: "📞" },
  { key: "WhatsApp",      icon: "💬" },
  { key: "Email",         icon: "📧" },
  { key: "Reunión",       icon: "🤝" },
  { key: "Visita en obra",icon: "🏗" },
  { key: "Otro",          icon: "📝" },
];

const TOKEN_SUNAT = process.env.REACT_APP_SUNAT_TOKEN;

const INITIAL = {
  ruc: "", nombre: "", empresa: "", direccion: "", proyecto: "",
  telefono: "", email: "", ciudad: "Lima",
  fuente: "Web", estado: "Nuevo", valor: "", prioridad: "3 - Media",
  responsable: "", proximoSeguimiento: "", notas: "",
};

const ACT_INICIAL = {
  tipo: "Llamada", fecha: (() => { const d=new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`; })(),
  descripcion: "", resultado: "", proximoContacto: "",
};

function fmtFecha(f) {
  if (!f) return "—";
  const [y, m, d] = f.split("-");
  return `${d}/${m}/${y}`;
}

function ActividadSection({ clienteId, clienteNombre, clienteEmpresa, responsable, onProximoContactoSet }) {
  const { actividades, loading, crearActividad, eliminarActividad } = useActividadesCliente(clienteId);
  const [mostrando,  setMostrando]  = useState(false);
  const [form,       setForm]       = useState(ACT_INICIAL);
  const [confirmDel, setConfirmDel] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await crearActividad({ ...form, clienteId, clienteNombre, clienteEmpresa, responsable });
    if (form.proximoContacto && onProximoContactoSet) {
      onProximoContactoSet(form.proximoContacto);
    }
    setForm(ACT_INICIAL);
    setMostrando(false);
  };

  const tipoIcon = (t) => TIPOS_ACTIVIDAD.find(x => x.key === t)?.icon || "📝";

  const hoyD = new Date();
  const hoy = `${hoyD.getFullYear()}-${String(hoyD.getMonth()+1).padStart(2,"0")}-${String(hoyD.getDate()).padStart(2,"0")}`;

  return (
    <div style={{ marginTop: 32 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <p style={{ fontSize: 11, fontWeight: 700, color: "#7C3AED", letterSpacing: "0.08em", textTransform: "uppercase", margin: 0 }}>
          Actividades y seguimiento
        </p>
        <button
          type="button"
          onClick={() => setMostrando(v => !v)}
          style={{ fontSize: 12, fontWeight: 600, padding: "6px 14px", borderRadius: 8, border: "none", background: "#7C3AED", color: "#fff", cursor: "pointer" }}
        >
          {mostrando ? "Cancelar" : "+ Registrar actividad"}
        </button>
      </div>

      {/* Formulario nueva actividad */}
      {mostrando && (
        <form onSubmit={handleSubmit} style={{ background: "#F5F3FF", border: "1px solid #DDD6FE", borderRadius: 10, padding: 16, marginBottom: 16 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            {/* Tipo */}
            <div>
              <label style={lbl}>Tipo de actividad</label>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {TIPOS_ACTIVIDAD.map(t => (
                  <button
                    key={t.key} type="button"
                    onClick={() => setForm(f => ({ ...f, tipo: t.key }))}
                    style={{
                      fontSize: 11, fontWeight: 600, padding: "5px 10px", borderRadius: 8, cursor: "pointer", border: "1.5px solid",
                      borderColor: form.tipo === t.key ? "#7C3AED" : "#e2e8f0",
                      background:  form.tipo === t.key ? "#EDE9FE" : "#fff",
                      color:       form.tipo === t.key ? "#7C3AED" : "#475569",
                    }}
                  >
                    {t.icon} {t.key}
                  </button>
                ))}
              </div>
            </div>

            {/* Fecha */}
            <div>
              <label style={lbl}>Fecha de la actividad</label>
              <input type="date" value={form.fecha} onChange={e => setForm(f => ({ ...f, fecha: e.target.value }))} style={inp} required />
            </div>

            {/* Descripción */}
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={lbl}>¿Qué pasó? (descripción)</label>
              <textarea
                value={form.descripcion} onChange={e => setForm(f => ({ ...f, descripcion: e.target.value }))}
                placeholder="Ej: Llamé al cliente, mostró interés en el proyecto de 3 pisos..."
                rows={2} required
                style={{ ...inp, resize: "vertical", paddingTop: 8, paddingBottom: 8 }}
              />
            </div>

            {/* Resultado */}
            <div>
              <label style={lbl}>Resultado / acuerdo</label>
              <input
                value={form.resultado} onChange={e => setForm(f => ({ ...f, resultado: e.target.value }))}
                placeholder="Ej: Enviar cotización la próxima semana"
                style={inp}
              />
            </div>

            {/* Próximo contacto */}
            <div>
              <label style={lbl}>Próximo contacto</label>
              <input
                type="date" value={form.proximoContacto}
                onChange={e => setForm(f => ({ ...f, proximoContacto: e.target.value }))}
                min={hoy}
                style={{ ...inp, borderColor: form.proximoContacto ? "#7C3AED" : "#e2e8f0" }}
              />
            </div>
          </div>
          <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
            <button type="submit" style={{ flex: 1, padding: "9px 0", background: "#7C3AED", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
              Guardar actividad
            </button>
            <button type="button" onClick={() => setMostrando(false)} style={{ padding: "9px 16px", border: "1px solid #e2e8f0", borderRadius: 8, background: "#fff", fontSize: 13, cursor: "pointer", color: "#475569" }}>
              Cancelar
            </button>
          </div>
        </form>
      )}

      {/* Timeline de actividades */}
      {loading ? (
        <div style={{ color: "#94a3b8", fontSize: 12, padding: "8px 0" }}>Cargando actividades...</div>
      ) : actividades.length === 0 ? (
        <div style={{ background: "#fafafa", border: "1px dashed #e2e8f0", borderRadius: 10, padding: "24px 16px", textAlign: "center", color: "#94a3b8", fontSize: 12 }}>
          Sin actividades registradas. Usa el botón de arriba para registrar un contacto, reunión o visita.
        </div>
      ) : (
        <div style={{ position: "relative" }}>
          {/* Línea vertical */}
          <div style={{ position: "absolute", left: 15, top: 0, bottom: 0, width: 2, background: "#f1f5f9" }} />
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {actividades.map(a => {
              return (
                <div key={a.id} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  {/* Círculo icono */}
                  <div style={{
                    width: 32, height: 32, borderRadius: "50%", flexShrink: 0,
                    background: "#EDE9FE", color: "#7C3AED",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 15, zIndex: 1,
                  }}>
                    {tipoIcon(a.tipo)}
                  </div>
                  {/* Contenido */}
                  <div style={{ flex: 1, background: "#fff", border: "0.5px solid #e2e8f0", borderRadius: 10, padding: "10px 14px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: "#7C3AED" }}>{a.tipo}</span>
                        <span style={{ fontSize: 10, color: "#94a3b8" }}>{fmtFecha(a.fecha)}</span>
                        {a.responsable && <span style={{ fontSize: 10, color: "#94a3b8" }}>· {a.responsable}</span>}
                      </div>
                      {confirmDel === a.id ? (
                        <div style={{ display: "flex", gap: 4 }}>
                          <button onClick={() => { eliminarActividad(a.id); setConfirmDel(null); }} style={{ fontSize: 9, padding: "2px 7px", borderRadius: 4, background: "#DC2626", color: "#fff", border: "none", cursor: "pointer", fontWeight: 600 }}>Sí</button>
                          <button onClick={() => setConfirmDel(null)} style={{ fontSize: 9, padding: "2px 6px", borderRadius: 4, background: "#f1f5f9", color: "#475569", border: "none", cursor: "pointer" }}>No</button>
                        </div>
                      ) : (
                        <button onClick={() => setConfirmDel(a.id)} style={{ fontSize: 9, padding: "2px 6px", borderRadius: 4, background: "none", color: "#94a3b8", border: "none", cursor: "pointer" }}>✕</button>
                      )}
                    </div>
                    <p style={{ fontSize: 12, color: "#1e293b", margin: "0 0 4px 0" }}>{a.descripcion}</p>
                    {a.resultado && (
                      <p style={{ fontSize: 11, color: "#475569", margin: "0 0 4px 0", fontStyle: "italic" }}>
                        → {a.resultado}
                      </p>
                    )}
                    {a.proximoContacto && (
                      <div style={{
                        display: "inline-flex", alignItems: "center", gap: 4,
                        fontSize: 10, fontWeight: 500, padding: "2px 8px", borderRadius: 6,
                        background: "#f1f5f9", color: "#64748b",
                        marginTop: 2,
                      }}>
                        📅 Acordado: {fmtFecha(a.proximoContacto)}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default function NuevoCliente({ editMode }) {
  const [form,        setForm]        = useState(INITIAL);
  const [loading,     setLoading]     = useState(false);
  const [buscandoRuc, setBuscandoRuc] = useState(false);
  const [rucMsg,      setRucMsg]      = useState("");

  const { crearCliente, actualizarCliente } = useClientes();
  const { usuarios } = useUsuarios();
  const navigate     = useNavigate();
  const { id }       = useParams();

  useEffect(() => {
    if (editMode && id) {
      getDoc(doc(db, "clientes", id)).then(snap => {
        if (snap.exists()) setForm({ ...INITIAL, ...snap.data() });
      });
    }
  }, [editMode, id]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const buscarDocumento = async (numero) => {
    const num = (numero || form.ruc || "").replace(/\D/g, "");
    if (num.length !== 8 && num.length !== 11) {
      setRucMsg("⚠ Ingresa 8 dígitos (DNI) o 11 dígitos (RUC)");
      return;
    }

    // 1. Caché local — respuesta instantánea si ya se consultó antes
    const cacheKey = `sunat_${num}`;
    try {
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        aplicarResultado(JSON.parse(cached), num);
        return;
      }
    } catch {}

    setBuscandoRuc(true);
    setRucMsg("Consultando SUNAT...");

    const tipo   = num.length === 11 ? "ruc" : "dni";
    const apiUrl = `https://dniruc.apisperu.com/api/v1/${tipo}/${num}?token=${TOKEN_SUNAT}`;

    const parsear = async (res) => {
      if (!res.ok) throw new Error("HTTP error");
      const json = await res.json();
      if (!json || typeof json !== "object") throw new Error("Sin datos");
      return json;
    };

    // apisperu.com permite CORS directo (Access-Control-Allow-Origin: *)
    let data = null;
    try {
      data = await fetch(apiUrl, { signal: AbortSignal.timeout(10000) }).then(parsear);
    } catch {
      setRucMsg("❌ Sin conexión a SUNAT. Intenta nuevamente.");
      setBuscandoRuc(false);
      return;
    }

    // 3. Guardar en caché si hay datos válidos
    if (data?.razonSocial || data?.nombres) {
      try { localStorage.setItem(cacheKey, JSON.stringify(data)); } catch {}
    }

    aplicarResultado(data, num);
    setBuscandoRuc(false);
  };

  const aplicarResultado = (data, num) => {
    if (num.length === 11 && data?.razonSocial) {
      setForm(f => ({ ...f, empresa: data.razonSocial || f.empresa, direccion: data.direccion || f.direccion }));
      setRucMsg(`✅ ${data.razonSocial}`);
    } else if (num.length === 8 && data?.nombres) {
      const nombreCompleto = `${data.nombres} ${data.apellidoPaterno} ${data.apellidoMaterno}`.trim();
      setForm(f => ({ ...f, nombre: nombreCompleto }));
      setRucMsg(`✅ ${nombreCompleto}`);
    } else {
      setRucMsg("❌ No encontrado en SUNAT");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const datos = { ...form, valor: Number(form.valor) || 0 };
    if (editMode && id) await actualizarCliente(id, datos);
    else await crearCliente(datos);
    setLoading(false);
    navigate("/clientes");
  };

  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 16px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 24 }}>
        <button onClick={() => navigate("/clientes")} style={{ background: "none", border: "none", color: "#64748b", cursor: "pointer", fontSize: 14 }}>
          ← Volver
        </button>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#1e293b" }}>
          {editMode ? "Editar cliente" : "Nuevo cliente"}
        </h1>
      </div>

      <form onSubmit={handleSubmit} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 24 }}>

        {/* DATOS DEL CLIENTE */}
        <div style={{ marginBottom: 24 }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: "#2563eb", letterSpacing: "0.08em", marginBottom: 16, textTransform: "uppercase" }}>
            Datos del cliente
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>

            <div style={{ gridColumn: "1 / -1" }}>
              <label style={lbl}>RUC o DNI <span style={{ fontWeight: 400, color: "#94a3b8" }}>(autocompleta desde SUNAT)</span></label>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input
                  name="ruc"
                  value={form.ruc || ""}
                  onChange={e => { handleChange(e); setRucMsg(""); }}
                  onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); buscarDocumento(); } }}
                  placeholder="RUC (11 dígitos) o DNI (8 dígitos)"
                  maxLength={11}
                  style={{ ...inp, flex: 1 }}
                />
                <button
                  type="button"
                  onClick={() => buscarDocumento()}
                  disabled={buscandoRuc}
                  style={{
                    padding: "9px 16px", borderRadius: 8, border: "none", cursor: buscandoRuc ? "not-allowed" : "pointer",
                    background: buscandoRuc ? "#e2e8f0" : "#2563eb", color: buscandoRuc ? "#94a3b8" : "#fff",
                    fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0,
                  }}
                >
                  {buscandoRuc ? "Buscando..." : "🔍 Buscar"}
                </button>
              </div>
              {rucMsg && (
                <div style={{
                  fontSize: 11, marginTop: 5, padding: "5px 10px", borderRadius: 6,
                  background: rucMsg.startsWith("✅") ? "#E1F5EE" : rucMsg.startsWith("⚠") ? "#FEF9C3" : "#FCEBEB",
                  color:      rucMsg.startsWith("✅") ? "#0F6E56"  : rucMsg.startsWith("⚠") ? "#854F0B" : "#A32D2D",
                }}>
                  {rucMsg}
                </div>
              )}
            </div>

            <div>
              <label style={lbl}>Nombre completo *</label>
              <input name="nombre" value={form.nombre} onChange={handleChange} required placeholder="Ej: Carlos Mendoza" style={inp} />
            </div>

            <div>
              <label style={lbl}>Empresa / Negocio</label>
              <input name="empresa" value={form.empresa} onChange={handleChange} placeholder="Ej: TechPeru SAC" style={inp} />
            </div>

            <div style={{ gridColumn: "1 / -1" }}>
              <label style={lbl}>Dirección <span style={{ fontWeight: 400, color: "#94a3b8" }}>(se autocompleta con el RUC)</span></label>
              <input name="direccion" value={form.direccion || ""} onChange={handleChange} placeholder="Ej: Av. Lima 123, Huánuco" style={inp} />
            </div>

            <div style={{ gridColumn: "1 / -1" }}>
              <label style={lbl}>Proyecto</label>
              <input name="proyecto" value={form.proyecto || ""} onChange={handleChange} placeholder="Ej: Edificio Residencial Torres del Norte" style={inp} />
            </div>

            <div>
              <label style={lbl}>Teléfono</label>
              <input name="telefono" value={form.telefono} onChange={handleChange} placeholder="Ej: 998-123-456" style={inp} />
            </div>

            <div>
              <label style={lbl}>Correo electrónico</label>
              <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Ej: carlos@empresa.com" style={inp} />
            </div>

            <div>
              <label style={lbl}>Departamento</label>
              <select name="ciudad" value={form.ciudad} onChange={handleChange} style={sel}>
                {DEPARTAMENTOS.map(o => <option key={o}>{o}</option>)}
              </select>
            </div>

            <div>
              <label style={lbl}>Fuente (¿cómo llegó?)</label>
              <select name="fuente" value={form.fuente} onChange={handleChange} style={sel}>
                {FUENTES.map(o => <option key={o}>{o}</option>)}
              </select>
            </div>

          </div>
        </div>

        {/* ESTADO DEL NEGOCIO */}
        <div style={{ marginBottom: 24 }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: "#2563eb", letterSpacing: "0.08em", marginBottom: 16, textTransform: "uppercase" }}>
            Estado del negocio
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div>
              <label style={lbl}>Estado</label>
              <select name="estado" value={form.estado} onChange={handleChange} style={sel}>
                {ESTADOS.map(o => <option key={o}>{o}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>Valor potencial (S/)</label>
              <input name="valor" type="number" value={form.valor} onChange={handleChange} placeholder="Ej: 5000" style={inp} />
            </div>
            <div>
              <label style={lbl}>Prioridad</label>
              <select name="prioridad" value={form.prioridad} onChange={handleChange} style={sel}>
                {PRIORIDAD.map(o => <option key={o}>{o}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>Responsable</label>
              <select name="responsable" value={form.responsable} onChange={handleChange} style={sel}>
                <option value="">— Seleccionar asesor —</option>
                {(usuarios||[]).filter(u => u.activo !== false).map(u => (
                  <option key={u.id} value={u.nombre}>{u.nombre}</option>
                ))}
              </select>
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={lbl}>Próximo seguimiento (sin cotización)</label>
              <input name="proximoSeguimiento" type="date" value={form.proximoSeguimiento} onChange={handleChange} style={{ ...inp, width: "50%" }} />
            </div>
          </div>
        </div>

        {/* NOTAS */}
        <div style={{ marginBottom: 24 }}>
          <label style={lbl}>Notas</label>
          <textarea name="notas" value={form.notas} onChange={handleChange} rows={3}
            placeholder="Observaciones, detalles importantes..."
            style={{ ...inp, resize: "vertical", height: "auto", paddingTop: 8, paddingBottom: 8 }} />
        </div>

        {/* BOTONES */}
        <div style={{ display: "flex", gap: 12 }}>
          <button type="submit" disabled={loading} style={{ flex: 1, background: "#2563eb", color: "#fff", border: "none", borderRadius: 8, padding: "11px 0", fontSize: 14, fontWeight: 600, cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.6 : 1 }}>
            {loading ? "Guardando..." : editMode ? "Guardar cambios" : "Crear cliente"}
          </button>
          <button type="button" onClick={() => navigate("/clientes")} style={{ padding: "11px 24px", border: "1px solid #e2e8f0", borderRadius: 8, background: "#fff", fontSize: 14, cursor: "pointer", color: "#475569" }}>
            Cancelar
          </button>
        </div>

      </form>

      {/* ACTIVIDADES — solo en modo edición */}
      {editMode && id && (
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 24, marginTop: 20 }}>
          <ActividadSection
            clienteId={id}
            clienteNombre={form.nombre}
            clienteEmpresa={form.empresa}
            responsable={form.responsable}
            onProximoContactoSet={(fecha) => setForm(f => ({ ...f, proximoSeguimiento: fecha }))}
          />
        </div>
      )}
    </div>
  );
}

const lbl = { display: "block", fontSize: 12, fontWeight: 600, color: "#475569", marginBottom: 6 };
const inp = { width: "100%", padding: "9px 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, color: "#1e293b", outline: "none", background: "#fff", fontFamily: "inherit", boxSizing: "border-box" };
const sel = { width: "100%", padding: "9px 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, color: "#1e293b", outline: "none", background: "#fff", fontFamily: "inherit", boxSizing: "border-box", cursor: "pointer" };
